<template>

</template>

<script>
  import {Message} from "element-ui";
  import {mapState} from "vuex";
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
    export default {
        name: "MyInfoView",
        mounted() {
          this.$router.push({path: '/user/create',query:{"flag": "view","isSelf":"1"}});
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/myInfo/MyInfoView.vue